// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let V4 = require("uuid/v4");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let NewPropertyPageRelayFormData_serverDraft_graphql = require("../../../__generated__/NewPropertyPageRelayFormData_serverDraft_graphql.bs.js");
let NewPropertyPageRelayFormData_inlineServerDraft_graphql = require("../../../__generated__/NewPropertyPageRelayFormData_inlineServerDraft_graphql.bs.js");

let forSalePropertyTypeEnumV5_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let leaseLengthValue_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.leaseLengthValue_decode;

let rentalPropertyTypeEnumV5_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let convertFragment = NewPropertyPageRelayFormData_serverDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NewPropertyPageRelayFormData_serverDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NewPropertyPageRelayFormData_serverDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NewPropertyPageRelayFormData_serverDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NewPropertyPageRelayFormData_serverDraft_graphql.node, convertFragment, fRef);
}

let ServerDraftFragment_draftV5Status_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.draftV5Status_decode;

let ServerDraftFragment_draftV5Status_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.draftV5Status_fromString;

let ServerDraftFragment_forSalePropertyTypeEnumV5_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let ServerDraftFragment_leaseLengthValue_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.leaseLengthValue_fromString;

let ServerDraftFragment_lotSizeUnit_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.lotSizeUnit_decode;

let ServerDraftFragment_lotSizeUnit_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.lotSizeUnit_fromString;

let ServerDraftFragment_mlsListingTypeV5_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.mlsListingTypeV5_decode;

let ServerDraftFragment_mlsListingTypeV5_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.mlsListingTypeV5_fromString;

let ServerDraftFragment_onOrOffV5_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.onOrOffV5_decode;

let ServerDraftFragment_onOrOffV5_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.onOrOffV5_fromString;

let ServerDraftFragment_rentalPropertyTypeEnumV5_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let ServerDraftFragment_showingTypeV5_decode = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.showingTypeV5_decode;

let ServerDraftFragment_showingTypeV5_fromString = NewPropertyPageRelayFormData_serverDraft_graphql.Utils.showingTypeV5_fromString;

let ServerDraftFragment = {
  draftV5Status_decode: ServerDraftFragment_draftV5Status_decode,
  draftV5Status_fromString: ServerDraftFragment_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: ServerDraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: leaseLengthValue_decode,
  leaseLengthValue_fromString: ServerDraftFragment_leaseLengthValue_fromString,
  lotSizeUnit_decode: ServerDraftFragment_lotSizeUnit_decode,
  lotSizeUnit_fromString: ServerDraftFragment_lotSizeUnit_fromString,
  mlsListingTypeV5_decode: ServerDraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: ServerDraftFragment_mlsListingTypeV5_fromString,
  onOrOffV5_decode: ServerDraftFragment_onOrOffV5_decode,
  onOrOffV5_fromString: ServerDraftFragment_onOrOffV5_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: ServerDraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: ServerDraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ServerDraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NewPropertyPageRelayFormData_inlineServerDraft_graphql.node, convertFragment$1, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(NewPropertyPageRelayFormData_inlineServerDraft_graphql.node, convertFragment$1, fRef);
}

let InlineServerDraftFragment_draftV5Status_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.draftV5Status_decode;

let InlineServerDraftFragment_draftV5Status_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.draftV5Status_fromString;

let InlineServerDraftFragment_forSalePropertyTypeEnumV5_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let InlineServerDraftFragment_forSalePropertyTypeEnumV5_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let InlineServerDraftFragment_leaseLengthValue_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.leaseLengthValue_decode;

let InlineServerDraftFragment_leaseLengthValue_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.leaseLengthValue_fromString;

let InlineServerDraftFragment_lotSizeUnit_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.lotSizeUnit_decode;

let InlineServerDraftFragment_lotSizeUnit_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.lotSizeUnit_fromString;

let InlineServerDraftFragment_mlsListingTypeV5_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.mlsListingTypeV5_decode;

let InlineServerDraftFragment_mlsListingTypeV5_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.mlsListingTypeV5_fromString;

let InlineServerDraftFragment_onOrOffV5_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.onOrOffV5_decode;

let InlineServerDraftFragment_onOrOffV5_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.onOrOffV5_fromString;

let InlineServerDraftFragment_rentalPropertyTypeEnumV5_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let InlineServerDraftFragment_rentalPropertyTypeEnumV5_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let InlineServerDraftFragment_showingTypeV5_decode = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.showingTypeV5_decode;

let InlineServerDraftFragment_showingTypeV5_fromString = NewPropertyPageRelayFormData_inlineServerDraft_graphql.Utils.showingTypeV5_fromString;

let InlineServerDraftFragment = {
  draftV5Status_decode: InlineServerDraftFragment_draftV5Status_decode,
  draftV5Status_fromString: InlineServerDraftFragment_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: InlineServerDraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: InlineServerDraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: InlineServerDraftFragment_leaseLengthValue_decode,
  leaseLengthValue_fromString: InlineServerDraftFragment_leaseLengthValue_fromString,
  lotSizeUnit_decode: InlineServerDraftFragment_lotSizeUnit_decode,
  lotSizeUnit_fromString: InlineServerDraftFragment_lotSizeUnit_fromString,
  mlsListingTypeV5_decode: InlineServerDraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: InlineServerDraftFragment_mlsListingTypeV5_fromString,
  onOrOffV5_decode: InlineServerDraftFragment_onOrOffV5_decode,
  onOrOffV5_fromString: InlineServerDraftFragment_onOrOffV5_fromString,
  rentalPropertyTypeEnumV5_decode: InlineServerDraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: InlineServerDraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: InlineServerDraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: InlineServerDraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  readInline: readInline
};

function serverDraftToLocalDraft(serverDraft) {
  let match = serverDraft.chapter;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.preferences;
    if (match$1 !== undefined) {
      let match$2 = match$1.mlsComingSoon;
      tmp = match$2 === "ON";
    } else {
      tmp = false;
    }
  } else {
    tmp = false;
  }
  let draftProperty = serverDraft.draftProperty;
  let tmp$1;
  if (draftProperty !== undefined) {
    let propertyData = draftProperty.propertyData;
    let commission;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataForSaleV5" :
          commission = propertyData.commission;
          break;
        case "DraftPropertyDataRentalV5" :
        case "__unselected" :
          commission = undefined;
          break;
      }
    } else {
      commission = undefined;
    }
    let match$3 = draftProperty.price;
    let match$4;
    if (match$3 !== undefined) {
      switch (match$3.__typename) {
        case "DraftPropertyPriceRange" :
          match$4 = [
            Stdlib_Option.map(match$3.minPrice, p => p.value),
            Stdlib_Option.map(match$3.maxPrice, p => p.value),
            true
          ];
          break;
        case "DraftPropertyExactPrice" :
        case "__unselected" :
          match$4 = [
            undefined,
            undefined,
            false
          ];
          break;
      }
    } else {
      match$4 = [
        undefined,
        undefined,
        false
      ];
    }
    let match$5 = draftProperty.price;
    let price;
    if (match$5 !== undefined) {
      switch (match$5.__typename) {
        case "DraftPropertyExactPrice" :
          price = Stdlib_Option.map(match$5.price, p => p.value);
          break;
        case "DraftPropertyPriceRange" :
        case "__unselected" :
          price = undefined;
          break;
      }
    } else {
      price = undefined;
    }
    let match$6;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
          match$6 = [
            propertyData.availableFrom,
            propertyData.leaseLength
          ];
          break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
          match$6 = [
            undefined,
            undefined
          ];
          break;
      }
    } else {
      match$6 = [
        undefined,
        undefined
      ];
    }
    let match$7 = draftProperty.displayNeighborhood;
    let tmp$2;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataForSaleV5" :
          tmp$2 = Stdlib_Option.flatMap(propertyData.forSalePropertyType, forSalePropertyTypeEnumV5_decode);
          break;
        case "DraftPropertyDataRentalV5" :
        case "__unselected" :
          tmp$2 = undefined;
          break;
      }
    } else {
      tmp$2 = undefined;
    }
    let match$8 = draftProperty.geocodingData;
    let tmp$3;
    if (match$8 !== undefined) {
      let lat = match$8.lat;
      if (lat !== undefined) {
        let lon = match$8.lon;
        if (lon !== undefined) {
          let standardizedAddress = match$8.standardizedAddress;
          if (standardizedAddress !== undefined) {
            let standardizedCity = match$8.standardizedCity;
            if (standardizedCity !== undefined) {
              let standardizedState = match$8.standardizedState;
              if (standardizedState !== undefined) {
                let standardizedZip = match$8.standardizedZip;
                tmp$3 = standardizedZip !== undefined ? ({
                    lat: lat,
                    lon: lon,
                    standardizedAddress: standardizedAddress,
                    standardizedCity: standardizedCity,
                    standardizedState: standardizedState,
                    standardizedZip: standardizedZip
                  }) : undefined;
              } else {
                tmp$3 = undefined;
              }
            } else {
              tmp$3 = undefined;
            }
          } else {
            tmp$3 = undefined;
          }
        } else {
          tmp$3 = undefined;
        }
      } else {
        tmp$3 = undefined;
      }
    } else {
      tmp$3 = undefined;
    }
    let tmp$4;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
          tmp$4 = "RENTAL";
          break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
          tmp$4 = "FOR_SALE";
          break;
      }
    } else {
      tmp$4 = "FOR_SALE";
    }
    let tmp$5;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
          tmp$5 = Stdlib_Option.flatMap(propertyData.rentalPropertyType, rentalPropertyTypeEnumV5_decode);
          break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
          tmp$5 = undefined;
          break;
      }
    } else {
      tmp$5 = undefined;
    }
    let match$9 = draftProperty.userSelectedArea;
    tmp$1 = {
      address: draftProperty.address,
      addressToGeocode: draftProperty.address,
      anonymousProperty: Stdlib_Option.getOr(draftProperty.anonymousProperty, false),
      availableFrom: match$6[0],
      baths: draftProperty.baths,
      beds: draftProperty.beds,
      commission: commission,
      description: draftProperty.description,
      displayNeighborhood: match$7 !== undefined ? ({
          id: match$7.id,
          label: match$7.label
        }) : undefined,
      files: Stdlib_Option.getOr(Stdlib_Option.map(draftProperty.files, files => Stdlib_Array.filterMap(files, f => {
        let contentType = f.contentType;
        if (contentType === undefined) {
          return;
        }
        let fileName = f.fileName;
        if (fileName !== undefined) {
          return {
            contentType: contentType,
            fileName: fileName,
            id: f.id,
            key: f.key
          };
        }
      })), []),
      forSalePropertyType: tmp$2,
      geocodingData: tmp$3,
      goingOnMls: draftProperty.goingOnMls,
      halfBaths: draftProperty.halfBaths,
      hideAddress: draftProperty.hideAddress,
      images: Stdlib_Option.getOr(Stdlib_Option.map(draftProperty.images, images => Stdlib_Array.filterMap(images, img => {
        let contentType = img.contentType;
        if (contentType === undefined) {
          return;
        }
        let fileName = img.fileName;
        if (fileName !== undefined) {
          return {
            contentType: contentType,
            fileName: fileName,
            id: img.id,
            key: img.key,
            previewUrl: img.url
          };
        }
      })), []),
      leaseLength: Stdlib_Option.flatMap(Stdlib_Option.map(match$6[1], p => p.value), leaseLengthValue_decode),
      livingArea: draftProperty.livingArea,
      lotSize: draftProperty.lotSize,
      lotSizeUnit: Stdlib_Option.getOr(draftProperty.lotSizeUnit, "SQ_FT"),
      maxPrice: match$4[1],
      minPrice: match$4[0],
      mlsListingType: draftProperty.mlsListingType,
      numberOfUnits: draftProperty.numberOfUnits,
      onMlsAt: draftProperty.onMlsAt,
      parkingDetails: draftProperty.parkingDetails,
      parkingSpaces: draftProperty.parkingSpaces,
      price: price,
      priceRange: match$4[2],
      propertyType: tmp$4,
      rentalPropertyType: tmp$5,
      selectedArea: match$9 !== undefined ? ({
          id: match$9.id,
          label: match$9.label
        }) : undefined,
      showings: Stdlib_Option.getOr(Stdlib_Option.map(draftProperty.showings, showings => showings.map(s => {
        let match = s.id;
        let match$1 = s.key;
        return {
          date: s.date,
          endTime: s.endTime,
          id: s.id,
          key: match !== undefined ? match : (
              match$1 !== undefined ? match$1 : V4()
            ),
          notes: s.notes,
          startTime: s.startTime,
          type_: s.typ
        };
      })), []),
      website: draftProperty.website,
      willAcceptOffers: draftProperty.willAcceptOffers,
      willShow: draftProperty.willShow
    };
  } else {
    tmp$1 = {
      address: undefined,
      addressToGeocode: undefined,
      anonymousProperty: false,
      availableFrom: undefined,
      baths: undefined,
      beds: undefined,
      commission: undefined,
      description: undefined,
      displayNeighborhood: undefined,
      files: [],
      forSalePropertyType: undefined,
      geocodingData: undefined,
      goingOnMls: undefined,
      halfBaths: undefined,
      hideAddress: undefined,
      images: [],
      leaseLength: undefined,
      livingArea: undefined,
      lotSize: undefined,
      lotSizeUnit: "SQ_FT",
      maxPrice: undefined,
      minPrice: undefined,
      mlsListingType: "ACTIVE",
      numberOfUnits: undefined,
      onMlsAt: undefined,
      parkingDetails: undefined,
      parkingSpaces: undefined,
      price: undefined,
      priceRange: false,
      propertyType: "FOR_SALE",
      rentalPropertyType: undefined,
      selectedArea: undefined,
      showings: [],
      website: undefined,
      willAcceptOffers: undefined,
      willShow: undefined
    };
  }
  return {
    chapterPreferenceMlsComingSoonActivated: tmp,
    draftProperty: tmp$1,
    message: serverDraft.message,
    serverDraftId: serverDraft.databaseId,
    status: serverDraft.status,
    subject: serverDraft.subject,
    timeZone: Stdlib_Option.getOr(Stdlib_Option.flatMap(serverDraft.chapter, c => c.timezone), "")
  };
}

function toDraftData(raw) {
  return serverDraftToLocalDraft(RescriptRelay_Fragment.readInlineData(NewPropertyPageRelayFormData_inlineServerDraft_graphql.node, convertFragment$1, raw));
}

let Form;

exports.Form = Form;
exports.ServerDraftFragment = ServerDraftFragment;
exports.InlineServerDraftFragment = InlineServerDraftFragment;
exports.serverDraftToLocalDraft = serverDraftToLocalDraft;
exports.toDraftData = toDraftData;
/* uuid/v4 Not a pure module */
